export default __webpack_public_path__ + "static/media/imagemin.b9392c0f.svg";